import React, {useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import "./SubPageHeader.css";
import DropdownNav from "../../Header/DropdownNav/DropdownNav";

export default function SubPageHeader() {
  // const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

     useEffect(() => {
      function updateHeaderHeight() {
        const header = document.querySelector(".subpage-header");
        const height = header ? header.offsetHeight : 0;
        document.documentElement.style.setProperty(
          "--subpage-header-height",
          height + "px"
        );
      }
  
      updateHeaderHeight();
      window.addEventListener("resize", updateHeaderHeight);
  
      return () => window.removeEventListener("resize", updateHeaderHeight);
    }, []);

  return (
    <>
      <header className="subpage-header">
        <div className="subpage-header-top">
          <img
            src="/images/ijacna-logo.png"
            alt="IJFMR Logo"
            className="subpage-header-logo"
          />
          <div className="subpage-header-text">
            <h1 className="subpage-header-title">
              International Journal of Advanced Communication and Network
              Applications (IJACNA)
            </h1>

            <p  className="subpage-header-meta">
              <span className="subpage-header-issn">
                E-ISSN: <strong>— </strong>
              </span>
              <span className="subpage-header-impact">
                • <strong>Scholarly Journal</strong>
              </span>
            </p>

            <p  className="subpage-header-desc">
              A <span className="highlight-red">Widely Indexed</span> Open
              Access Multidisciplinary{" "}
              <span className="highlight-red">Bi-monthly </span>
              Scholarly <span className="highlight-red">
                International
              </span>{" "}
              Journal
            </p>
          </div>

          <button
            className="subpage-menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </header>
       <div  className="subpage-header-alert">
        <strong>(November–December 2025)</strong> — Submit your research{" "}
        <span className="highlight-yellow">before last 3 days of December</span>{" "}
        to publish your paper in the upcoming issue.
      </div>
      {/* Pass menu state to dropdown nav */}
      <DropdownNav menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
    </>
  );
}
